import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getGLAccount,
  getParticularPage,
  getNext,
  getPrevious,
  // filter by glAccount id
  getGLAccountById,
  handleSearch,
} from "./thunk";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  glAccounts: [],
  edit: false,
  glAccount: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingGLAccount: false,
  loadingNext: false,
  contactDetails: [],
  documents: [],
  showCreateModal: false,
};

export const glAccountSlice = createSlice({
  name: "glAccount",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    clearAllGLAccount: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingGLAccount = false;
      state.glAccount = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGLAccountById.pending, (state) => {
      state.glAccount = null;
      state.edit = true;
    });
    builder.addCase(getGLAccountById.fulfilled, (state, action) => {
      state.glAccount = action.payload.data;
    });

    builder.addCase(getGLAccountById.rejected, (state) => {
      state.glAccount = null;
      state.edit = false;
    });

    builder.addMatcher(
      isAnyOf(
        getGLAccount.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingGLAccount = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getGLAccount.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingGLAccount = false;
        state.glAccounts = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGLAccount.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingGLAccount = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllGLAccount } = glAccountSlice.actions;

export default glAccountSlice.reducer;
